import type { Candidate, MatchingDetailsFlag } from "../../../TalentsStatusAPI";

export const matchingDetailsWarningKeys = (candidate: Candidate): string[] => {
  const warningFlags = new Set<MatchingDetailsFlag>();
  Object.values(candidate.matchingDetails || {}).forEach(
    (detail: { flags?: MatchingDetailsFlag[] } | undefined) => {
      detail?.flags?.forEach((flag) => warningFlags.add(flag));
    },
  );

  const hasMissingWorkTitle = warningFlags.has("WorkTitleMissing");

  const hasMissingRequirement = [
    "TrainingMissing",
    "CertificateMissing",
    "LanguageSkillMissing",
    "LanguageSkillLevelIncomplete",
  ].some((flag) => warningFlags.has(flag as MatchingDetailsFlag));
  const hasIncompleteRequirement = [
    "TrainingIncomplete",
    "CertificateIncomplete",
  ].some((flag) => warningFlags.has(flag as MatchingDetailsFlag));
  const hasMissingSkill = warningFlags.has("SkillMissing");

  return [
    ...(hasMissingWorkTitle
      ? ["matchingDetailsWarnings.missingWorkTitle"]
      : []),
    ...(hasMissingRequirement
      ? ["matchingDetailsWarnings.missingRequirement"]
      : []),
    ...(hasIncompleteRequirement
      ? ["matchingDetailsWarnings.incompleteRequirement"]
      : []),
    ...(hasMissingSkill ? ["matchingDetailsWarnings.missingSkill"] : []),
  ];
};
